module.exports = __webpack_public_path__ + "static/media/overlay_tunnel_hint.0c4ea55b.png";